import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { SelectionItem } from '../../../core/component/select/select.component';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LocalDate } from '../../../core/model/local-date';

@Component({
    selector: 'app-select-date-dialog',
    templateUrl: './select-date-dialog.component.html',
    styleUrls: ['./select-date-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SelectDateDialogComponent implements OnInit {
  constructor(
    private _fb: FormBuilder,
    private _fc: FormControlExFactory,
    private _modalService: ActionWindowService
  ) {}

  form: FormGroup;
  parentForm: FormGroup;

  ngOnInit() {
    this.parentForm = this._fb.group({
      date: this._fb.group({}),
    });
    this.form = this.parentForm.controls['date'] as FormGroup;
    this.value = this.dataContext.defaultValue;
  }

  dataContext: {
    mandatory: boolean;
    fieldName: string;
    helpText: string;
    title: string;
    defaultValue: LocalDate;
  };

  value: LocalDate;

  onSubmit() {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }
    this._modalService.complete({ value: this.value });
  }

  cancel() {
    this._modalService.close();
  }
}
